import React from "react";
import {
  Col,
  Row,
  Select,
  Button,
  Space,
  message,
  Tooltip,
  Form,
  Upload,
  Image,
  Avatar,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleOdometerStore from "../store/VehicleOdometerStore";
import withRouter from "../withRouter";

import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";
import VehicleOdometerAdd from "./VehicleOdometerAdd";
import config from "../config";
import { decode as base64_decode } from "base-64";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";
import VehicleOdometerListFields from "./Plugins/AddVehicle/VehicleOdometerListFields";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import recordIcon from "../assets/images/NewDesign/records-grey.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";

const { Option } = Select;
const { Dragger } = Upload;
class VehicleOdometerList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleOdometerStore = new VehicleOdometerStore();
    this.workingHoursStore = new VehicleWorkingHoursStore();
    this.companyStore = new CompanyStore();
    this.cookies = new Cookies();
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadData: 0,
      offset: 0,
      limit: 50,
      selectedVehicles: "",
      companyVal_Lab: "",
      openOdometerId: "",
      openOdometerAddForm: false,
      listDataUpdate: false,
      showUpload: false,
      companyFieldHighlight: false,
    };

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <Link
              style={{ textDecoration: "none" }}
              to="/vehicleodometerrecords"
            >
              {" "}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {" "}
                <Avatar
                  style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                  src={recordIcon}
                ></Avatar>
                {context.translate("_RECORDS_")}
              </div>
            </Link>
          ),
          key: "records",
        },
      ],
    };

    this.columns = [
      {
        title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
        dataIndex: "company",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (company) => (
          <Tooltip placement="topLeft" title={company}>
            {company}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_FLEET_REPORTS_VEHICLENO_"),
        dataIndex: "vehicleNo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_GPS_ODOMETER_"),
        dataIndex: "gpsOdo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_CHANGE_ODOMETER_"),
        dataIndex: "odometer",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DATE_TIME_"),
        dataIndex: "datetime",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        title: context.translate("_ODOMETER_TRAVELLED_"),
        dataIndex: "travelledOdo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_TOTAL_ODOMETER_"),
        dataIndex: "totalOdo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DIFF_ODOMETER_"),
        dataIndex: "diffOdo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_CREATED_DATE_"),
        dataIndex: "createDate",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
    ];
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setOdometer = this.context.viewStateStore.vehicleOdometerObject;

      await this.setState({ companyId: setOdometer.companyId });
      // await this.workingHoursStore.getAssignAsset({
      //   companyId: setOdometer.companyId,
      // });

      if (setOdometer.companyId !== "") {
        await this.vehicleOdometerStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setOdometer.companyId,
          vehicleId: this.state.selectedVehicles,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setOdometer.companyId
        );
        await this.workingHoursStore.getAssignVehicles({
          companyId: setOdometer.companyId,
        });
        await this.setState({ loadList: 1 });

        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
      // await this.vehicleOdometerStore.loadData({ offset: 0, limit: 50 });
    }
  }
  async componentDidMount() {
    // console.log(this.viewStateStore.)
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      const data = await this.workingHoursStore.getAssignVehicles({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ companyVal_Lab: singleData });
    // await this.setState({ companyId: comp.value });
    await this.setState({ selectedVehicles: "" });
    const data = await this.workingHoursStore.getAssignVehicles({
      companyId: comp.value,
    });

    await this.setState({ loadData: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleOdometerStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
    });

    await this.setState({ loadData: 1 });
  }

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      this.setState({ openOdometerAddForm: false });
      this.setState({ listDataUpdate: true });
      // this.props.navigate("/vehicleodometerlist");
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["username"]);
      });
    }
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.excelCompanyId,
      excelFile: this.state.excelFile,
    };

    if (data.excelFile) {
      const resp = await this.vehicleOdometerStore.addOdometerByExcel(data);

      if (resp?.success == "S") {
        message.success(resp.message);
        this.setState({ showUpload: false });
        this.setState({ excelFile: "" });
        this.handleSearch();
      } else {
        message.error(resp.message);
      }
      if (resp.message) {
        this.setState({ showUpload: false });
        this.formRef.current?.resetFields();
      }
    } else {
      message.error("Please Upload Excel File");
    }
  };

  closeModal = () => {
    this.setState({ openOdometerAddForm: false, openOdometerId: "" });
  };

  handleUploadClick = () => {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
      this.setState({ showUpload: false });
    } else {
      this.setState({ companyFieldHighlight: false });
      this.setState({ showUpload: true });
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleOdometerStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        vehicleId: "",
      });
    }
    this.setState({ loading: false, selectedVehicles: "", currentPage: 1 });
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "1px solid red", width: "150px", borderRadius: "25px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => {
                    this.handleChange(value);
                  }}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  style={companyInputBox}
                />

                <Select
                  className="searchInput"
                  placeholder={this.context.translate(
                    "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                  )}
                  style={{ width: 200 }}
                  value={
                    this.state.selectedVehicles
                      ? this.state.selectedVehicles
                      : null
                  }
                  onChange={async (val) => {
                    await this.setState({ selectedVehicles: val });
                    await this.handleSearch();
                    await this.setState({ loadData: 1 });
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.workingHoursStore?.assignAssetList?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip title={this.context.translate("_REFRESH_")}>
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "15px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <VehicleOdometerListFields
                  menusDropDown={this.ExportMenuProps}
                  handleUploadClick={this.handleUploadClick}
                />
                {this.props.canCreate("VehicleOdometerList") && (
                  <Button
                    className="addButtonClass"
                    onClick={() => this.setState({ openOdometerAddForm: true })}
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.vehicleOdometerStore?.total}
            columns={this.columns}
            dataSource={this.vehicleOdometerStore?.vehicleOdometerVehicles}
            loading={this.vehicleOdometerStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openOdometerAddForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openOdometerAddForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADJUST_ODOMETER_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_ODOMETER_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openOdometerAddForm: false })}
            onCancel={() =>
              this.setState({
                openOdometerAddForm: false,
                openOdometerId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleOdometerAdd
                openOdometerId={this.state.openOdometerId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}
        {this.state.showUpload && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showUpload}
              placement={this.context.locale.language === "english" ? "right" : "left"}
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={UploadTitleIcon}
                  ></Image>
                  <span> {this.context.translate("_UPLOAD_EXCEL_TITLE_")}</span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ margin: "16px 0px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true }]}
                    required={false}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        this.setState({ excelCompanyId: companyId.value });
                      }}
                    />
                  </Form.Item>
                )}
                <Dragger
                  onRemove={() =>
                    this.setState({ excelFile: "", fileList: [] })
                  }
                  name="excelFile"
                  action={
                    // config.baseURL + "/index.php?c=company&a=fileupload"
                    config.baseURL + this.vehicleOdometerStore.fileUploadUrl
                  }
                  listType="text"
                  data={{
                    fileType: "accountimport",
                    fieldName: "excelFile",
                  }}
                  onChange={this.getUploadData}
                  // beforeUpload={(file) => this.validateFile(file)}
                  maxCount={1}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={uploadOutlined}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button
                      onClick={(val) => {
                        var colList = "vehicleNo,distance,date,time";
                        if (true) {
                          var getData = {
                            companyId: this.state.companyId,
                            isadmin: JSON.parse(
                              base64_decode(this.cookies.get("data"))
                            ).isadmin,
                            userId: JSON.parse(
                              base64_decode(this.cookies.get("data"))
                            ).userId,
                            colList: colList,
                          };

                          if (val) {
                            this.vehicleOdometerStore.exportExcel(getData);
                          }
                        }
                      }}
                    >
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showUpload: false,
                        excelFile: "",
                        companyId: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    className="uploadButton"
                    // onClick={() => this.onExcelSubmit()}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}
          </>
        )}
      </>
    );
  }
}
VehicleOdometerList.contextType = StoreContext;
export default observer(withRouter(VehicleOdometerList));
